import React from 'react';
import { TIME_RANGES } from '../../utils/constants';

interface TimeRangeSelectorProps {
  selectedHours: number;
  onRangeChange: React.Dispatch<React.SetStateAction<number>>;
}

export const TimeRangeSelector: React.FC<TimeRangeSelectorProps> = ({
  selectedHours,
  onRangeChange,
}) => {
  const ranges = [
    { hours: TIME_RANGES.HOUR, label: 'Last Hour' },
    { hours: TIME_RANGES.SIX_HOURS, label: 'Last 6 Hours' },
    { hours: TIME_RANGES.DAY, label: 'Last 24 Hours' },
    { hours: TIME_RANGES.WEEK, label: 'Last Week' },
    { hours: TIME_RANGES.MONTH, label: 'Last Month' },
  ];

  return (
    <select
      value={selectedHours}
      onChange={(e) => onRangeChange(Number(e.target.value))}
      style={{
        padding: '0.5rem 1rem',
        borderRadius: '0.5rem',
        fontSize: '0.875rem',
        fontWeight: 500,
        backgroundColor: 'rgba(28, 28, 30, 0.8)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        color: '#ffffff',
        cursor: 'pointer',
        outline: 'none',
      }}
      onFocus={(e) => {
        e.target.style.borderColor = '#007AFF';
        e.target.style.boxShadow = '0 0 0 3px rgba(0, 122, 255, 0.2)';
      }}
      onBlur={(e) => {
        e.target.style.borderColor = 'rgba(255, 255, 255, 0.1)';
        e.target.style.boxShadow = 'none';
      }}
    >
      {ranges.map((range) => (
        <option key={range.hours} value={range.hours} style={{ backgroundColor: '#1c1c1e', color: '#ffffff' }}>
          {range.label}
        </option>
      ))}
    </select>
  );
};

